import React, { useEffect, useState } from 'react';
import { Menu, X, Phone } from 'lucide-react';
import { motion, AnimatePresence } from 'framer-motion';
import { Link, useLocation } from 'react-router-dom';
import { Button } from './ui/Button';
export function Navbar() {
  const [isScrolled, setIsScrolled] = useState(false);
  const [isMobileMenuOpen, setIsMobileMenuOpen] = useState(false);
  const location = useLocation();
  useEffect(() => {
    const handleScroll = () => {
      setIsScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);
  const navLinks = [{
    name: 'Services',
    href: '/services',
    isRoute: true
  }, {
    name: 'About',
    href: '/about',
    isRoute: true
  }, {
    name: 'Why Us',
    href: '/#why-us',
    isRoute: false
  }, {
    name: 'Contact',
    href: '/#contact',
    isRoute: false
  }];
  return <header className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${isScrolled ? 'bg-white/95 backdrop-blur-sm shadow-sm py-3' : 'bg-transparent py-5'}`} data-id="element-113" data-mp="9opwdbkkul1n">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-114" data-mp="jmnl006cmjus">
        <div className="flex items-center justify-between" data-id="element-115" data-mp="jn6s0lugnnu1">
          {/* Logo */}
          <Link to="/" className="flex items-center gap-1.5 group" data-id="element-116" data-mp="okfdavawo7zi">
            <img src="https://cdn.magicpatterns.com/uploads/r2Qpm7TVH9yfhMg7exMXJN/IMG_2424.png" alt="Fix & Finish Logo" className="h-12 w-auto" data-id="element-117" data-mp="3n3w0iddlt7mc" />
            <div className="flex flex-col" data-id="element-118" data-mp="vmb4h3ox3wg">
              <span className={`text-xl font-bold leading-none ${isScrolled ? 'text-[#17a2b8]' : 'text-[#17a2b8]'}`} data-id="element-119" data-mp="uuse6v6z0nl">
                FIX & FINISH
              </span>
              <span className={`text-xs font-medium tracking-wider ${isScrolled ? 'text-[#525252]' : 'text-[#525252]'}`} data-id="element-120" data-mp="34cmej4mncqdv">
                PDX CONTRACTING
              </span>
            </div>
          </Link>

          {/* Desktop Nav */}
          <nav className="hidden md:flex items-center gap-8" data-id="element-121" data-mp="2wb5c0lxqrx9n">
            {navLinks.map(link => link.isRoute ? <Link key={link.name} to={link.href} className="text-[#2c2c2c] hover:text-[#17a2b8] font-medium transition-colors" data-id="element-122" data-mp="3b0b65vhq2xao">
                  {link.name}
                </Link> : <a key={link.name} href={link.href} className="text-[#2c2c2c] hover:text-[#17a2b8] font-medium transition-colors" data-id="element-123" data-mp="2dem8qd9md3l0">
                  {link.name}
                </a>)}
            <Button variant="primary" size="sm" leftIcon={<Phone className="h-4 w-4" data-id="element-125" data-mp="2lsu7ionuxls" />} onClick={() => window.location.href = 'tel:5036068823'} data-id="element-124" data-mp="7jkwn6mxm248">
              (503) 606-8823
            </Button>
          </nav>

          {/* Mobile Menu Button */}
          <button className="md:hidden p-2 text-[#2c2c2c]" onClick={() => setIsMobileMenuOpen(!isMobileMenuOpen)} aria-label="Toggle menu" data-id="element-126" data-mp="f4ogtlczwcjn">
            {isMobileMenuOpen ? <X className="h-6 w-6" data-id="element-127" data-mp="57s6rb7g7icz" /> : <Menu className="h-6 w-6" data-id="element-128" data-mp="sv0es0w9h5ip" />}
          </button>
        </div>
      </div>

      {/* Mobile Menu */}
      <AnimatePresence data-id="element-129" data-mp="xtv4znwk5wcu">
        {isMobileMenuOpen && <motion.div initial={{
        opacity: 0,
        height: 0
      }} animate={{
        opacity: 1,
        height: 'auto'
      }} exit={{
        opacity: 0,
        height: 0
      }} className="md:hidden bg-white border-t border-gray-100 overflow-hidden" data-id="element-130" data-mp="k3hw9jbuedmg">
            <div className="px-4 py-6 space-y-4 flex flex-col" data-id="element-131" data-mp="3p1nmffxieh3f">
              {navLinks.map(link => link.isRoute ? <Link key={link.name} to={link.href} className="text-lg font-medium text-[#2c2c2c] py-2 border-b border-gray-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-132" data-mp="3k22nh5ica8qp">
                    {link.name}
                  </Link> : <a key={link.name} href={link.href} className="text-lg font-medium text-[#2c2c2c] py-2 border-b border-gray-50" onClick={() => setIsMobileMenuOpen(false)} data-id="element-133" data-mp="6nxtm5yi84mo">
                    {link.name}
                  </a>)}
              <Button variant="primary" className="w-full mt-4" leftIcon={<Phone className="h-4 w-4" data-id="element-135" data-mp="plinjrg4lte5" />} onClick={() => window.location.href = 'tel:5036068823'} data-id="element-134" data-mp="uf3a8nc9r0y1">
                Call Now
              </Button>
            </div>
          </motion.div>}
      </AnimatePresence>
    </header>;
}